import { FC, useState } from "react";
import arrowDown from "../../../assets/arrowDown.svg";
import "./ColumnBoardList.css";

interface IdName {
    id: number;
    name: string;
}

interface ColumnBoardListProps {
    columns?: IdName[];
    boards?: IdName[];
    selectedColumn?: IdName;
    onClickColumn?: (column: IdName) => void;
    selectedBoard?: IdName;
    onClickBoard?: (board: IdName) => void;
    defaultColumn?: IdName | undefined;
}

export const ColumnBoardList: FC<ColumnBoardListProps> = ({
    columns,
    boards,
    selectedColumn,
    onClickColumn,
    selectedBoard,
    onClickBoard,
    defaultColumn,
}) => {
    const [open, setOpen] = useState<boolean>(false);

    return (
        <div className="column-board-list-container">
            <div className="column-board-list-selected" onClick={() => setOpen(!open)}>
                <span>
                    {selectedColumn
                        ? selectedColumn.name
                        : selectedBoard
                        ? selectedBoard.name
                        : defaultColumn
                        ? defaultColumn.name
                        : "Выбрать"}
                </span>
                <img alt="arrowDown" src={arrowDown} style={open ? { rotate: "180deg" } : { rotate: "0deg" }} />
            </div>
            {open ? (
                <>
                    <div className="column-board-list-dropdown">
                        <label className="list-label">Переместить в колонку</label>
                        {columns?.map((c) => (
                            <div
                                className="list-option"
                                onClick={() => {
                                    onClickColumn && onClickColumn(c);
                                    setOpen(false);
                                }}
                            >
                                {c.name.length > 20 ? c.name?.slice(0, 20) + "..." : c.name}
                            </div>
                        ))}
                        <label className="list-label">На доску</label>
                        {boards?.map((b) => (
                            <div
                                className="list-option"
                                onClick={() => {
                                    onClickBoard && onClickBoard(b);
                                    setOpen(false);
                                }}
                            >
                                {b.name.length > 20 ? b.name?.slice(0, 20) + "..." : b.name}
                            </div>
                        ))}
                    </div>
                    <div
                        style={{ opacity: "0.5" }}
                        className="full-screen-overlay_dropdown"
                        onClick={() => setOpen(false)}
                    ></div>
                </>
            ) : null}
        </div>
    );
};
